module.exports = __webpack_public_path__ + "img/home-phone.610eace6.png";